/**
 * Footer strip: save state on the left ("only visible to you" is the privacy promise the
 * whole feature makes — keep it), open to-do count on the right.
 * @param {{ saveState: 'saved'|'saving'|'error', hasBlocks: boolean, openTodoCount: number }} props
 */
function NotesStatusBar({ saveState, hasBlocks, openTodoCount }) {
  let dotClass = 'bg-ok';
  let label = hasBlocks ? 'Saved · only visible to you' : 'Ready';
  if (saveState === 'saving') {
    dotClass = 'bg-amb';
    label = 'Saving…';
  } else if (saveState === 'error') {
    dotClass = 'bg-rose-500';
    label = "Couldn't save — will retry";
  }
  return (
    <div className="flex h-[26px] shrink-0 items-center gap-1.5 border-t border-border bg-card px-3 text-[10.5px] text-muted-foreground">
      <span className={`size-1.5 rounded-full ${dotClass}`} aria-hidden />
      <span>{label}</span>
      {openTodoCount > 0 ? (
        <span className="ml-auto">
          {openTodoCount} open to-do{openTodoCount === 1 ? '' : 's'}
        </span>
      ) : null}
    </div>
  );
}

export default NotesStatusBar;
